(ns firebase.auth
  (:require
    ["firebase/auth" :as auth]
    [firebase.core :as core :refer [ADMIN_SDK]]
    [promises.core :refer-macros [await->]]))

(defn instance
  ([] (instance @core/app))
  ([^js app] 
   (let [a (auth/getAuth app)]
     (when-not ADMIN_SDK
       (await-> 
         (auth/getRedirectResult a)
         (catch [err] (js/console.error err))))
     a)))

(defn- user->clj [^js/firebase.auth.User user]
  (some-> user .toJSON (js->clj :keywordize-keys true)))

(when ADMIN_SDK
  
  (defn get-user [^js auth uid]
    (user->clj (.getUser auth uid)))
  
  (defn create-custom-token 
    "Generate a login token for user `uid`. The token is
    valid for 1 hour. It can be used as login credentials
    on the client, for user `uid`."
    [uid]
    
    (.createCustomToken ^js (instance) uid))
  
  (defn id-token->uid 
    "Get application User ID from a Firebase identity token."
    [^js/Firebase.DecodedToken token]
    
    (if-let [uid (.-uid token)]
      uid
      (throw "no uid")))
  
  (defn exchange-token 
    "Receive a Firebase identity token, return a login token"      
    [id-token]
    
    (await->
      (.verifyIdToken ^js (instance) id-token)
      id-token->uid
      create-custom-token))
  
  (defn token->userdata
    "Receive Firebase user details in exchange with an identity
    token. Returns keys `:auth-time :email-verified :email :phone-number :picture :uid`."
    [id-token]
    
    (await-> 
      (.verifyIdToken ^js (instance) id-token)
      (then 
        [^js/Firebase.DecodedToken token]
        (when-not token 
          (throw "no decoded token"))
        {:auth-time (.-auth_time token)
         :email-verified (.-email_verified token)
         :email (.-email token)
         :phone-number (.-phone_number token)
         :picture (.-picture token)
         :uid (.-uid token)})))
  )

(when-not ADMIN_SDK
  
  (defn current-user
    ([] (current-user (instance)))
    ([^js auth] (user->clj (.-currentUser auth))))
  
  (defn get-id-token
    "Returns a promise resolving to the current user's ID token,
     or nil if no user is signed in."
    ([] (get-id-token (instance)))
    ([^js auth]
     (when-let [^js user (.-currentUser auth)]
       (.getIdToken user))))  
  
  (defn sign-in-with-email [^js auth email password]
    (auth/signInWithEmailAndPassword auth email password))
  
  (defn sign-in-with-google
    ([mode] (sign-in-with-google (instance) mode))
    ([^js auth mode]
     (let [provider (auth/GoogleAuthProvider.)]
       (await-> 
         (case mode 
           :redirect (auth/signInWithRedirect auth provider)
           :popup (auth/signInWithPopup auth provider))
         (js/console.log)
         (catch [err] (js/console.error err))))))
  
  (defn sign-out 
    ([] (sign-out (instance)))
    ([^js auth] (auth/signOut auth)))
  
  (defn on-auth-state-changed [^js auth callback]
    ;; Returns a function that unsubscribes the listener
    (auth/onAuthStateChanged auth callback))
  
  (defn track-current-user! 
    ([user&] 
     (track-current-user! (instance) user&))
    
    ([^js auth user&]
     (on-auth-state-changed 
       auth 
       (fn [data] 
         (reset! user& (user->clj data))))))
  
 )
